<div class="wrap">
  <app-video-coaching [url]="url"></app-video-coaching>
</div>
